import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function ReservationDetails() {
  const { id } = useParams();
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newDate, setNewDate] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchReservation = async () => {
      try {
        const docRef = doc(db, "reservations", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setReservation({ id: docSnap.id, ...docSnap.data() });
        } else {
          setReservation(null);
        }
      } catch (error) {
        console.error("Erreur :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReservation();
  }, [id]);

  const handleProlongation = async () => {
    if (!newDate) {
      setMessage("Veuillez choisir une nouvelle date.");
      return;
    }

    try {
      const docRef = doc(db, "reservations", reservation.id);
      await updateDoc(docRef, {
        prolongationDemandee: true,
        nouvelleDateFin: newDate
      });
      setMessage("Demande de prolongation envoyée ✅");
      setReservation((prev) => ({
        ...prev,
        prolongationDemandee: true,
        nouvelleDateFin: newDate
      }));
    } catch (error) {
      console.error("Erreur de mise à jour :", error);
      setMessage("Erreur lors de la demande.");
    }
  };

  if (loading) return <div className="container py-5">Chargement...</div>;
  if (!reservation) return <div className="container py-5">Réservation introuvable.</div>;

  const whatsappMessage = `Bonjour, je souhaite confirmer ma réservation pour le véhicule ${reservation.vehicule || `${reservation.marque ?? ""} ${reservation.modele ?? ""}`} du ${reservation.dateDebut} au ${reservation.dateFin}.`;

  return (
    <div className="container py-5">
      <h2 className="mb-4">Détails de votre réservation</h2>

      <div className="card shadow-sm">
        {reservation.imageUrl && (
          <img
            src={reservation.imageUrl}
            alt="Véhicule réservé"
            className="card-img-top"
            style={{ maxHeight: 300, objectFit: "cover" }}
          />
        )}

        <div className="card-body">
          <h5 className="card-title">{reservation.nom}</h5>
          <p><strong>Téléphone :</strong> {reservation.telephone}</p>
          <p><strong>Véhicule :</strong> {reservation.vehicule || `${reservation.marque ?? ""} ${reservation.modele ?? ""}`}</p>
          <p><strong>Période :</strong> du {reservation.dateDebut} au {reservation.dateFin}</p>
          <p><strong>Statut :</strong> <span className="badge bg-info text-dark">{reservation.statut}</span></p>
          <p className="text-muted"><small>Créée le : {reservation.createdAt?.toDate().toLocaleString()}</small></p>

          {reservation.prolongationDemandee && reservation.nouvelleDateFin && (
            <div className="alert alert-warning mt-3">
              📅 Une demande de prolongation jusqu’au <strong>{reservation.nouvelleDateFin}</strong> est en attente de validation.
            </div>
          )}

          {!reservation.prolongationDemandee &&
  (reservation.statut === "validée" || reservation.statut === "en attente de validation") && (
    <div className="mt-4">
      <h6>Demander une prolongation</h6>
      <input
        type="date"
        className="form-control mb-2"
        value={newDate}
        onChange={(e) => setNewDate(e.target.value)}
        min={reservation.dateFin}
      />
      <button className="btn btn-outline-primary" onClick={handleProlongation}>
        📩 Envoyer la demande
      </button>
      {message && <p className="mt-2 text-info">{message}</p>}
    </div>
)}



          <div className="d-flex justify-content-between flex-wrap mt-4 gap-2">
            <Link to="/locations" className="btn btn-outline-secondary">← Retour</Link>
            <a
              href={`https://wa.me/22878815494?text=${encodeURIComponent(whatsappMessage)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success"
            >
              Contacter WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
